'use client';
/**
 * Разбивает исходный массив на `n` массивов.
 *
 * @typeParam T - Элемент массива.
 *
 * @param array - Массив или одно значение.
 * @param chunkSize - Количество элементов в пакете.
 *
 * @returns Массив пакетов.
 *
 * @note Размер последнего пакета может быть произвольным (<= `chunkSize`),
 * так как в последний пакет попадают оставшиеся элементы.
 *
 * @primaryExample
 * chunk([1, 2, 3, 4, 5], 2) // [[1, 2], [3, 4], [5]]
 *
 * @stable
 * */ var chunks = function(array, chunkSize) {
    var chunks = [];
    var i = 0;
    var n = array.length;
    while(i < n){
        chunks.push(array.slice(i, i += chunkSize));
    }
    return chunks;
};

export { chunks };
